interface AcoreShared {
  SHARED_CONTEXT: Record<string, unknown>;
  SHARED_HOOKS: Record<string, unknown>;
}

declare global {
  interface Window {
    ACORE: AcoreShared;
    'autobots-full': any;
  }
}

window.ACORE = window.ACORE || {};

window.ACORE.SHARED_CONTEXT = window.ACORE.SHARED_CONTEXT || {};
window.ACORE.SHARED_HOOKS = window.ACORE.SHARED_HOOKS || {};

function addSharedContext(key: string, value: unknown) {
  window.ACORE.SHARED_CONTEXT[key] = value;
}

function getSharedContext(key: string) {
  return window.ACORE.SHARED_CONTEXT[key];
}

function addSharedHooks(key: string, value: unknown) {
  window.ACORE.SHARED_HOOKS[key] = value;
}

function getSharedHooks(key: string) {
  return window.ACORE.SHARED_HOOKS[key];
}

export { addSharedContext, getSharedContext, addSharedHooks, getSharedHooks };
